import { selectArticle, selectCurrentCategory, selectSearchedText } from '../../common/selectors/helpCenter';
import { selectSolutions } from '../../common/selectors/solutions';
import { Page } from '../../common/types';
import { biLogger } from '../biLogger';
import { BiEventLogger } from '../types';
import { pageEnumToString } from '../utils';

type CurrentPageBiData = Readonly<{
  currentPage: Page;
  unreadCount: number;
  previousPage?: Page;
}>;

// Helper function to get page-specific content, can we use solutionInfo instead?
const getPageSpecificContent = (currentPage: Page, state: any): Record<string, any> => {
  switch (currentPage) {
    case Page.Article: {
      const article = selectArticle(state);
      return {
        articleId: article?.id?.toString(),
        articleTitle: article?.title,
        categoryId: article?.categoryId?.toString(),
        articleType: article?.type,
      };
    }
    case Page.Categories:
    case Page.Category: {
      const category = selectCurrentCategory(state);
      return {
        categoryId: category?.id?.toString(),
        categoryName: category?.name,
        categoryUri: category?.uri,
        parentCategoryId: category?.parentId?.toString(),
      };
    }
    case Page.Search: {
      const searchQuery = selectSearchedText(state);
      const solutions = selectSolutions(state);
      return {
        searchQuery,
        resultsCount: solutions?.length || 0,
      };
    }
    case Page.Home: {
      // TODO: add homepage content
      return {
        pageType: 'homepage',
      };
    }
    default:
      return {};
  }
};

export const logHelpWidgetPageView: BiEventLogger<CurrentPageBiData> = async (
  state,
  { currentPage, unreadCount, previousPage },
) => {
  const pageType = pageEnumToString(currentPage);
  const previousPageType = previousPage ? pageEnumToString(previousPage) : undefined;
  const pageContent = getPageSpecificContent(currentPage, state);
  const presentedContent = Object.keys(pageContent).length ? JSON.stringify(pageContent) : undefined;

  await biLogger.helpWidgetPageViewNew(state, {
    widget_page_type: pageType,
    notification_count: unreadCount,
    previous_widget_page_type: previousPageType,
    presented_content: presentedContent,
  });
};
